import React, { useEffect, useRef, useState } from "react";
import tw from "tailwind-styled-components";
import {
    InputGroup,
    SideCancelBtn,
    SubmitBtn,
    ActionSection,
    ScrollableContent,
    Wrapper,
    FieldWrappers,
    ModalHeader,
} from "../Styles/InputStyles";
import { MdClose } from "react-icons/md";
import { Formik, Form, Field } from "formik";
import CategoryCard from "../CategoryCard";

import * as Yup from "yup";
import SinglePropSelectModal from "../SinglePropSelectModal";
import ModalProfileHeader from "../Common/ModalProfileHeader";
import { capitalizeFirstLetter } from "../../helpers";

const SwitchStampModal = ({
    handleClose,
    setIsSwitchStamp,
    selectedData,
    switchStampMutate,
    switchStampLoading,
    properties,
}) => {
    const formikRef = useRef(null);
    const [showPropertyModal, setShowPropertyModal] = useState(false);
    const [selectedProperty, setSelectedProperty] = useState(null);
    const [height, setHeight] = useState(window.innerHeight);

    const filteredProperties = properties?.filter(
        (item) => item?.id !== selectedProperty?.id
    );

    // Yup Validation Schema
    const validationSchema = Yup.object().shape({
        property: Yup.string().required("Please select a property"),
        switchStamp: Yup.number()
            .required("Number of stamps is required")
            .positive("Must be greater than 0")
            .min(1, "Minimum 1 stamp required")
            .max(selectedData?.available || 0, `Cannot exceed available stamps (${selectedData?.available || 0})`)
            .typeError("Must be a valid number"),
    });


    useEffect(() => {
        if (formikRef.current) {
            formikRef.current.resetForm();
        }
        const handleResize = () => {
            setHeight(window.innerHeight);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (formikRef.current && selectedProperty) {
            formikRef.current.setFieldValue("property", selectedProperty.id);
        }
    }, [selectedProperty]);

    const initialValues = {
        property: selectedProperty ? selectedProperty.id : "",
        switchStamp: "",
    };

    const handleSelectedProperty = (selectedOption) => {
        setSelectedProperty(selectedOption);
        if (formikRef.current) {
            formikRef.current.setFieldValue("property", selectedOption.id);
        }
    };
    const handleSubmit = (values, { resetForm }) => {
        const payload = {
            propId: selectedData?.propId,
            toPropId: Number(values.property),
            noOfStamps: Number(values.switchStamp),
        };
        switchStampMutate(payload);
    };

    return (
        <Container
            style={{
                height: `${height}px`,
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
            }}
        >
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Switch Stamp</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <ModalProfileHeader
                title="Due Details"
                name={capitalizeFirstLetter(selectedData?.propName)}
                subtitle={`${selectedData?.streetAddress}`}
                amountLabel={"Available Stamps"}
                amount={selectedData?.available}
                image={selectedData?.profilePicture}
                onClose={handleClose}
                showCurrency={false}
            />

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                    innerRef={formikRef}
                    enableReinitialize
                >
                    {({ values, setFieldValue, errors, touched }) => {
                        return (
                            <Form>
                                <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                    <Wrapper>

                                        {filteredProperties && filteredProperties.length > 0 && (
                                            <InputGroup>
                                                <Label>Select Property *</Label>
                                                <CategoryCard
                                                    title="Property"
                                                    selectedCategory={selectedProperty}
                                                    onClick={() => setShowPropertyModal(true)}
                                                />
                                                {errors.property && touched.property && (
                                                    <ErrorText>{errors.property}</ErrorText>
                                                )}
                                            </InputGroup>
                                        )}
                                        <InputGroup>
                                            <Label>Number of Stamps to Switch *</Label>
                                            <FieldWrappers>
                                                <Field
                                                    type="number"
                                                    name="switchStamp"
                                                    id="switchStamp"
                                                    autoComplete="off"
                                                    className={`w-full ${errors.switchStamp && touched.switchStamp ? "border-red-500" : ""}`}
                                                    placeholder={`Enter number of stamps (Max: ${selectedData?.available || 0})`}
                                                    // min="1"
                                                    // max={selectedData?.available || 0}
                                                    step="1"
                                                    // onChange={(e) => {
                                                    //     const value = e.target.value;
                                                    //     if (value === "" || (Number(value) >= 1 && Number(value) <= (selectedData?.available || 0))) {
                                                    //         setFieldValue("switchStamp", value);
                                                    //     }
                                                    // }}
                                                    onChange={(e) => {
                                                        setFieldValue("switchStamp", e.target.value);
                                                    }}
                                                />
                                            </FieldWrappers>
                                            {errors.switchStamp && touched.switchStamp && (
                                                <ErrorText>{errors.switchStamp}</ErrorText>
                                            )}
                                            {/* <HelpText>
                                                * You can switch up to {selectedData?.available || 0} stamps
                                            </HelpText> */}

                                        </InputGroup>
                                        <AvailabilityNote>
                                            <div>
                                                <p className="text-xs uppercase tracking-widest text-green-500 font-semibold">
                                                    Remaining After Switch
                                                </p>

                                                <h2 className="text-3xl font-bold text-green-600 leading-none mt-2">
                                                    {Math.max(
                                                        (selectedData?.available || 0) -
                                                        Number(values.switchStamp || 0),
                                                        0
                                                    )}
                                                </h2>
                                            </div>

                                            <div className="text-right">
                                                <p className="text-xs text-gray-500">
                                                    Switching{" "}
                                                    <span className="font-semibold">
                                                        {Number(values.switchStamp || 0)}
                                                    </span>{" "}
                                                    stamps
                                                </p>
                                            </div>
                                        </AvailabilityNote>
                                    </Wrapper>
                                </ScrollableContent>

                                <ActionSection>
                                    <SideCancelBtn type="button" onClick={handleClose}>
                                        Cancel
                                    </SideCancelBtn>
                                    <SubmitBtn type="submit" disabled={switchStampLoading}>
                                        {switchStampLoading ? "Submitting..." : "Submit"}
                                    </SubmitBtn>
                                </ActionSection>

                                {/* Property Selection Modal */}
                                <SinglePropSelectModal
                                    isOpen={showPropertyModal}
                                    onClose={() => setShowPropertyModal(false)}
                                    onSelect={handleSelectedProperty}
                                    options={filteredProperties}
                                    selectedProperty={selectedProperty}
                                />
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </Container>
    );
};

const Label = tw.label`text-sm text-gray-500 font-normal`;
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
const ErrorText = tw.div`text-red-500 text-sm mt-1`;
const AvailabilityNote = tw.div`
    mt-2
    p-5
    rounded-lg
    bg-gradient-to-br
    from-blue-50
    via-white
    to-indigo-50
    border
    border-blue-100
    flex
    items-center
    justify-between
    shadow-sm
    transition-all
`;
const HelpText = tw.div`
    mt-1
    text-xs
    text-gray-400
`;

export default SwitchStampModal;